import React, { useRef, useState } from "react";
import FileInput from "./FileInput";
import FileInputGallery from "./FileInputGallery";
import "./GlobalForm.css";
import NestedInput from "./NestedInput";
import NestedInputImage from "./NestedInputImage";
import NestedInputMultiple from "./NestedInputMultiple";
import SelectTag from "./SelectTag";
import TextAreaInput from "./TextAreaInput";
import TextInput from "./TextInput";
import TextInputObject from "./TextInputObject";
import { FaPaperPlane, FaRegPaperPlane } from "react-icons/fa";
import HeadingTitle from "./HeadingTitle";

const GlobalForm = ({
  data,
  nestedData,
  nestedGalleryData,
  multiDimensionalData,
  multiDimensionalDataText,
  multiDimensionalDataImage,
  multiDimensionalMultipleData,
  update,
  deleteBtn,
  updateBtn,
  helperFunction,
}) => {
  const [newData] = useState(data);

  const formRef = useRef();

  const inputElement = (item, index) => {
    const { elementType } = item;
    if (elementType === "input") {
      return <TextInput key={index} item={item} />;
    } else if (elementType === "inputObject") {
      return <TextInputObject key={index} item={item} />;
    } else if (elementType === "textField") {
      return <TextAreaInput key={index} item={item} />;
    } else if (elementType === "file") {
      return <FileInput key={index} item={item} />;
    } else if (elementType === "gFile") {
      return <FileInputGallery key={index} item={item} />;
    } else if (elementType === "nested") {
      return <NestedInput key={index} item={item} />;
    } else if (elementType === "nestedText") {
      return <NestedInput key={index} item={item} text={true} />;
    } else if (elementType === "nestedImage") {
      return <NestedInputImage key={index} item={item} />;
    } else if (elementType === "nestedMultiple") {
      return <NestedInputMultiple key={index} item={item} />;
    } else if (elementType === "select") {
      return <SelectTag key={index} item={item} />;
    } else if (elementType === "heading") {
      return <HeadingTitle key={index} item={item} />;
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const submitData = {};
    data?.map(
      (item) =>
        (submitData[item.name] = formRef.current[item.name]?.value
          ? formRef.current[item.name].type === "password"
            ? formRef.current[item.name]?.value
            : formRef.current[item.name]?.value?.trim()
          : formRef.current[item.name]?.src)
    );

    nestedData &&
      nestedData.map((item) => {
        const temp = [];
        formRef.current[item.name].length
          ? formRef.current[item.name].forEach((element) => {
              element.alt
                ? temp.push({
                    _id: element.alt,
                    url: element.value ? element?.value : element?.src,
                  })
                : temp.push(element.value ? element?.value : element?.src);
            })
          : temp.push({
              _id: formRef.current[item.name].alt,
              url: formRef.current[item.name].value
                ? formRef.current[item.name].value
                : formRef.current[item.name].src,
            });
        submitData[item.name] = temp;
      });

    nestedGalleryData &&
      nestedGalleryData.map((item) => {
        const temp = [];
        if (formRef.current[item.name]?.length) {
          formRef.current[item.name]?.forEach((element, idx) => {
            element.alt
              ? temp.push({
                  _id: element.alt,
                  url: element.value ? element?.value : element?.src,
                  imgId: idx + 1,
                })
              : temp.push(element.value ? element?.value : element?.src);
          });
        }
        // else {
        //   temp.push({
        //     _id: formRef.current[item.name]?.alt,
        //     url: formRef.current[item.name]?.value
        //       ? formRef.current[item.name]?.value
        //       : formRef.current[item.name]?.src,
        //   });
        // }
        submitData[item.name] = temp;
      });

    multiDimensionalData &&
      multiDimensionalData.map((item) => {
        const temp = [];
        formRef.current[item.name]?.length > 0
          ? formRef.current[item.name].forEach((element) => {
              temp.push([
                element.parentNode.children[0]?.value,
                element?.value,
              ]);
            })
          : temp.push([
              formRef.current[item.name].parentNode.children[0]?.value,
              formRef.current[item.name]?.value,
            ]);

        submitData[item.name] = temp;
      });

    multiDimensionalDataText &&
      multiDimensionalDataText.map((item) => {
        const temp = [];

        formRef.current[item.name].length
          ? formRef.current[item.name].forEach((element) => {
              temp.push([
                element.parentNode.children[0].children[1].value,
                element?.value,
              ]);
            })
          : temp.push([
              formRef.current[item.name].parentNode.children[0]?.value,
              formRef.current[item.name]?.value,
            ]);
        submitData[item.name] = temp;
      });

    multiDimensionalDataImage &&
      multiDimensionalDataImage.map((item) => {
        const temp = [];
        const tempImage = [];
        const tempLink = [];
        formRef.current[item.name].length
          ? formRef.current[item.name].forEach((element) => {
              const image = element.parentNode.children[1]?.src;
              const link = element?.value;
              image && tempImage.push(image);
              link && tempLink.push(link);
            })
          : temp.push([
              formRef.current[item.name].parentNode.children[1]?.value,
              formRef.current[item.name]?.value,
            ]);

        for (let i = 0; i < tempLink.length; i++) {
          temp.push([tempImage[i] ? tempImage[i] : "", tempLink[i]]);
        }
        submitData[item.name] = temp;
      });

    multiDimensionalMultipleData &&
      multiDimensionalMultipleData.map((item) => {
        const temp = [];
        const tempTitle = [];
        const tempParagraph = [];
        const tempImage = [];

        formRef.current[item.name].length
          ? formRef.current[item.name].forEach((element) => {
              const title = element.type === "text" ? element.value : "";
              const image = element.type === "file" ? element.src : "";
              const paragraph =
                element.type === "textarea" ? element.value : "";

              title && tempTitle.push(title);
              paragraph && tempParagraph.push(paragraph);
              image && tempImage.push(image);
            })
          : temp.push([
              formRef.current[item.name].parentNode.children[1]?.value,
              formRef.current[item.name]?.value,
            ]);

        for (let i = 0; i < tempTitle.length; i++) {
          temp.push({
            title: tempTitle[i],
            paragraph: tempParagraph[i],
            image: tempImage[i] ? tempImage[i] : "",
          });
        }

        submitData[item.name] = temp;
      });
    update(submitData);
  };

  return (
    <div className="container mx-auto lg:pt-12 py-10 md:px-5">
      <form ref={formRef} onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 justify-items-center gap-8 gap-y-4 pb-8">
          {newData?.map((item, index) => inputElement(item, index))}
        </div>

        <div className="flex justify-center pt-4 gap-8">
          <button
            type="submit"
            className="btn btnW7ide font-bold text-white bg-secondary hover:bg-[#025250] hover:shadow-lg px-12 py-3 rounded-lg transition duration-150"
          >
            {updateBtn ? "Update" : "Submit"}
            <FaPaperPlane className="inline ml-2.5 mb-0.5 text-sm" />
          </button>
          {deleteBtn && (
            <button
              type="button"
              onClick={helperFunction}
              className="btn btnW7ide border-2 text-red-500 font-bold border-red-500 hover:text-white hover:border-red-500 hover:bg-red-500 hover:shadow-md px-10 py-2.5 rounded-xl transition duration-150"
            >
              Delete
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default GlobalForm;
